import type { PubsubHttpMessageWrapper } from "./pubsub-push-message";
import type {
    PubSubPushVerificationErrorMessage} from "./pubsub-push-verification-error";
import {
    PubSubPushVerificationError
} from "./pubsub-push-verification-error";

const parsePubSubPushMessage = <T extends Record<string, unknown>>(
    pushMessage: PubsubHttpMessageWrapper,
    verificationChecks: Array<
        (result: T) => Array<PubSubPushVerificationErrorMessage>
    > = [],
): T => {
    const value = Buffer.from(pushMessage.message.data, "base64").toString();
    const data = JSON.parse(value) as T;
    const verificationErrors = verificationChecks.flatMap(check => check(data));
    if (verificationErrors.length)
        throw new PubSubPushVerificationError(verificationErrors);

    return data;
};

export { parsePubSubPushMessage };
